// Place types and categories for JewMap

export type PlaceCategory = 'restaurant' | 'synagogue' | 'grocery' | 'mikvah' | 'community' | 'bakery' | 'butcher';

export type VerificationStatus = 'validated' | 'under_review' | 'pending';

export type KosherStatus = 'kosher' | 'kosher_dairy' | 'kosher_meat' | 'kosher_pareve' | 'glatt_kosher' | 'not_kosher' | 'unknown';

export interface Place {
  id: string;
  name: string;
  category: PlaceCategory;
  lat: number;
  lng: number;
  address: string;
  city: string;
  country: string;
  postalCode?: string;
  photos: string[];
  kosherStatus?: KosherStatus;
  kosherAuthority?: string;
  openingHours?: {
    [key: string]: { open: string; close: string } | null;
  };
  phone?: string;
  website?: string;
  email?: string;
  instagram?: string;
  facebook?: string;
  description?: string;
  verificationStatus: VerificationStatus;
  distance?: number; // in km
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  promotedRank?: number;
  rating?: number;
  reviewCount?: number;
  priceRange?: number;
}

export interface Review {
  id: string;
  userId: string;
  placeId: string;
  rating: number;
  title: string | null;
  content: string | null;
  photos: string[];
  helpfulCount: number;
  verifiedVisit: boolean;
  createdAt: string;
  updatedAt: string;
  // Joined data
  userDisplayName: string;
  userAvatarUrl: string | null;
}

export interface Category {
  id: PlaceCategory;
  name: string;
  icon: string;
  color: string;
}

export const CATEGORIES: Category[] = [
  { id: 'restaurant', name: 'Restaurants', icon: '🍽️', color: 'primary' },
  { id: 'synagogue', name: 'Synagogues', icon: '✡️', color: 'primary' },
  { id: 'grocery', name: 'Épiceries', icon: '🛒', color: 'primary' },
  { id: 'bakery', name: 'Boulangeries', icon: '🥖', color: 'primary' },
  { id: 'butcher', name: 'Boucheries', icon: '🥩', color: 'primary' },
  { id: 'mikvah', name: 'Mikvaot', icon: '💧', color: 'primary' },
  { id: 'community', name: 'Communauté', icon: '🏛️', color: 'primary' },
];

export const getCategoryIcon = (category: PlaceCategory): string => {
  const cat = CATEGORIES.find(c => c.id === category);
  return cat?.icon || '📍';
};

export const getCategoryName = (category: PlaceCategory): string => {
  const cat = CATEGORIES.find(c => c.id === category);
  return cat?.name || 'Place';
};
